import postal from 'postal';
import React from 'react';
import ReactDOM from 'react-dom';
import isEmpty from 'underscore/modules/isEmpty';
import { PageStrings } from '@alltrails/shared/utils/pageStringHelpers';
import TabBar from '../../../../../components/shared/TabBar';
import { FullscreenBreadcrumbBar } from './breadcrumb_bar';
import { FullscreenLifelineDetails } from './lifeline_details';
import SearchFilterBar from '../../../../../components/explore/SearchFilterBar';
import { FullscreenSearchMap } from './search_map';
import { FullscreenSearchResultList } from './search_result_list';
import TrackPanel from '../../../../../components/Tracks/TrackPanel';
import { FullscreenTrailDetailsFrame } from './trail_details_frame';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';
import { modalSignup } from '../../../../../utils/modal_funnel_util';
import { ResultCardFunctionsMixin } from '../../mixins/result_card_functions_mixin';
import { ResultCountMixin } from '../../mixins/search_app/result_count_mixin';
import { SearchAppAlgoliaMixin } from '../../mixins/search_app/search_app_algolia_mixin';
import { SearchFiltersUtil } from '../../../../../utils/search_filters_util';
import { ServerCommunicationUtil } from '../../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../../mixins/shared/string_constants_mixin';
import { renderShareModal } from '../../main_action_bar/share_modal';
import ReviewFormModal from '../../../../../components/forms/ReviewFormModal';
import PhotoUploadModal from '../../../../../components/forms/PhotoUploadModal';
import TrackUploadModal from '../../../../../components/forms/TrackUploadModal';
import ActivityUploadModal from '../../../../../components/forms/ActivityUploadModal';
import DownloadRouteModal from '../../../../../components/DownloadRouteModal';
import { wrapEventHandler } from '../../../../../utils/handlers';
import MapCreatorPanel from '../../../../../components/MapCreator/Panel';
import ProgressDialog from '../../../../../components/shared/ProgressDialog';
import { FILTER, MAP_PAN } from '../../../../../utils/constants/SearchAnalyticsConstants';
import { loadVerifiedRoute, saveAtMap, saveNewEndpoint, updateAtMap, copyRoute } from '../../../../../utils/requests/at_map_requests';
import { isMapFaulty } from '../../../../../utils/at_map_helpers';
import { logCommunityContentClicked, logCommunityContentItemClicked } from '../../../../../utils/explore_analytics_helpers';
import { getFormattedTrailUrls } from '../../../../../utils/trail_helpers';
import { copyList, reorderList } from '../../../../../utils/requests/list_requests';
import logError from '../../../../../utils/logError';
import SearchEmptyState from '../../../../../components/shared/SearchEmptyState';
import BookmarkIcon from '../../../../../../assets/images/icons/search/bookmark.svg';
import MapIcon from '../../../../../../assets/images/icons/search/map.svg';
import PointerIcon from '../../../../../../assets/images/icons/search/pointer.svg';
import { Page } from '../../../../../components/shared/Page/Page';
import { checkLinkAndAppendLanguage } from '../../../../../utils/localization';

const {
  strings: {
    ICON,
    EMPTY_STATES: {
      FAVORITES: { KEEP_TRACK, TAP_THE_HEART_ICON, START_EXPLORING },
      MAPS: { PLAN_YOUR_PERFECT_ROUTE, MAP_CREATOR_TOOL, CREATE_MAP },
      ACTIVITIES: { KEEP_TRACK_ACTIVITIES, SAVE_ACTIVITIES, UPLOAD_FILE },
      COMPLETED: { COMPLETE_TRAILS, COMPLETED_TAB_LIST },
      CUSTOM: { BUILD_PERSONAL_LIST, PERSONAL_LIST_SUBTEXT }
    }
  }
} = StringConstantsMixin;

const createReactClass = require('create-react-class');

const MAX_ALLOWED_EXPLORE_TRAIL_COUNT = 0;
const ET_PHOTO_USER_SLUG = 'alltrails-user';
// Lifeline constants
const LIFELINE_STATUS_SAFE = 'S';

// !!!!!!!!!!
// NOTE: We work with algolia results as trails for easiness
// This means that the trail.trail_id is in the algolia result as ID
// access it with result.ID, aka result.ID == trail.trail_id
const FullscreenSearchApp = createReactClass({
  mixins: [ResultCardFunctionsMixin, ResultCountMixin, SearchAppAlgoliaMixin],
  getInitialFilters() {
    let allFilters = this.newSearchFilters();
    // Return early
    if (!this.props.initialFilters) {
      return allFilters;
    }

    if (this.props.initialFilters.query) {
      allFilters = SearchFiltersUtil.setFilter(allFilters, 'queryTerm', this.props.initialFilters.query);
    }
    if (this.props.initialFilters.activities) {
      this.props.initialFilters.activities.forEach(filter => {
        allFilters = SearchFiltersUtil.toggleFilter(allFilters, 'activities', filter);
      });
    }
    if (this.props.initialFilters.features) {
      this.props.initialFilters.features.forEach(filter => {
        allFilters = SearchFiltersUtil.toggleFilter(allFilters, 'features', filter);
      });
    }
    if (this.props.initialFilters.access) {
      this.props.initialFilters.access.forEach(filter => {
        allFilters = SearchFiltersUtil.toggleFilter(allFilters, 'access', filter);
      });
    }
    if (this.props.initialFilters.areas) {
      this.props.initialFilters.areas.forEach(areaId => {
        // add "fake" area entry without name (because Algolia data has not been retrieved yet)
        areaId = parseInt(areaId);
        allFilters.areas[areaId] = {
          value: areaId,
          selected: true
        };
      });
    }
    if (this.props.initialFilters.difficulty) {
      this.props.initialFilters.difficulty.forEach(filter => {
        allFilters = SearchFiltersUtil.toggleFilter(allFilters, 'difficulty', filter);
      });
    }
    if (this.props.initialFilters.route_type) {
      this.props.initialFilters.route_type.forEach(filter => {
        allFilters = SearchFiltersUtil.toggleFilter(allFilters, 'route_type', filter);
      });
    }
    if (this.props.initialFilters.visitor_usage) {
      this.props.initialFilters.visitor_usage.forEach(filter => {
        allFilters = SearchFiltersUtil.toggleFilter(allFilters, 'visitor_usage', filter);
      });
    }
    // these values will be supplied in meters, -1 also signifies maximum value
    if (this.props.initialFilters.lengths && this.props.initialFilters.lengths.length === 2) {
      const sliderValues = {
        displayRange: [Math.round(this.props.initialFilters.lengths[0] / allFilters.lengths.multiplier)],
        convertedRange: [this.props.initialFilters.lengths[0]]
      };
      if (this.props.initialFilters.lengths[1] === -1) {
        sliderValues.displayRange.push(allFilters.lengths.upperBound);
        sliderValues.convertedRange.push(-1);
      } else {
        sliderValues.displayRange.push(Math.round(this.props.initialFilters.lengths[1] / allFilters.lengths.multiplier));
        sliderValues.convertedRange.push(this.props.initialFilters.lengths[1]);
      }

      allFilters = SearchFiltersUtil.sliderFilter(allFilters, 'lengths', sliderValues);
    }
    if (this.props.initialFilters.elevation_gain && this.props.initialFilters.elevation_gain.length === 2) {
      const sliderValues = {
        displayRange: [Math.round(this.props.initialFilters.elevation_gain[0] / allFilters.elevation_gain.multiplier)],
        convertedRange: [this.props.initialFilters.elevation_gain[0]]
      };
      if (this.props.initialFilters.elevation_gain[1] === -1) {
        sliderValues.displayRange.push(allFilters.elevation_gain.upperBound);
        sliderValues.convertedRange.push(-1);
      } else {
        sliderValues.displayRange.push(Math.round(this.props.initialFilters.elevation_gain[1] / allFilters.elevation_gain.multiplier));
        sliderValues.convertedRange.push(this.props.initialFilters.elevation_gain[1]);
      }

      allFilters = SearchFiltersUtil.sliderFilter(allFilters, 'elevation_gain', sliderValues);
    }
    if (this.props.initialFilters.trailIds) {
      allFilters = SearchFiltersUtil.setFilter(allFilters, 'trailIds', this.props.initialFilters.trailIds);
    }
    if (this.props.initialFilters.trackIds) {
      allFilters = SearchFiltersUtil.setFilter(allFilters, 'trackIds', this.props.initialFilters.trackIds);
    }
    if (this.props.initialFilters.mapIds) {
      allFilters = SearchFiltersUtil.setFilter(allFilters, 'mapIds', this.props.initialFilters.mapIds);
    }
    if (this.props.initialFilters.minRating) {
      allFilters = SearchFiltersUtil.setFilter(allFilters, 'minRating', this.props.initialFilters.minRating);
    }
    if (this.props.initialFilters.boundingBox) {
      const newBounds = this.props.initialFilters.boundingBox;
      allFilters = SearchFiltersUtil.setBoundsFilter(
        allFilters,
        newBounds.latitudeTopLeft,
        newBounds.longitudeTopLeft,
        newBounds.latitudeBottomRight,
        newBounds.longitudeBottomRight
      );
    }
    if (this.props.initialFilters.mobileMap) {
      allFilters = SearchFiltersUtil.setFilter(allFilters, 'mobileMap', this.props.initialFilters.mobileMap);
    }
    if (this.props.initialFilters.locationObject) {
      allFilters = SearchFiltersUtil.setFilter(allFilters, 'locationObject', this.props.initialFilters.locationObject);
      allFilters = SearchFiltersUtil.setFilter(allFilters, 'initLocationObject', this.props.initialFilters.locationObject);
      if (this.props.initialCenter) {
        allFilters.initLocationObject._geoloc = {
          lat: this.props.initialCenter[0],
          lng: this.props.initialCenter[1]
        };
      }
    }
    return allFilters;
  },
  getInitialBackReturnsToExplore() {
    return (
      (this.props.initialPage === PageStrings.EXPLORE_USERS_TRACKS_PAGE || this.props.initialPage === PageStrings.EXPLORE_USERS_MAPS_PAGE) &&
      (!this.props.initialAtMaps || (this.props.initialAtMaps && this.props.initialAtMaps.length === 0))
    );
  },
  getInitialState() {
    this.resultCardFunctions = this.getResultCardFunctions();

    return {
      page: this.props.initialPage || PageStrings.EXPLORE_ALL_PAGE,
      results: this.props.initialResults,
      loading: true,
      trackTrail: this.props.initialTrackTrailResult,
      atMaps: this.props.initialAtMaps, // Used for client-side sorting through list of atMaps, as opposed to using Algolia
      selectedObject: this.props.initialSelectedObject,
      lifeline: this.props.initialLifeline,
      exploreMap: this.props.initialExploreMap,
      routeInfo: null, // in-progress trail planner routeInfo
      filters: this.getInitialFilters(),
      isMobileWidth: this.props.context.mobileBrowser || false,
      backReturnsToExplore: this.getInitialBackReturnsToExplore(),
      customList: this.props.initialCustomList,
      titleString: this.props.initialTitleString,
      listCopyString: StringConstantsMixin.strings.LIST_COPY,
      numberViewedTrails: this.props.numberViewedTrails || 0,
      isEditing: false,
      progressDialogState: null,
      displayMetric: this.props.context.displayMetric,
      nearbyTrailsShown: false,
      saveToList: null,
      showShareModal: false,
      shareObject: null,
      activeTrailFormModal: this.props.pendingReview !== null ? 'reviews' : null,
      trailFormProps: this.props.pendingReview,
      downloadObject: null,
      showDownloadRouteModal: false,
      searchTrigger: null
    };
  },
  componentWillMount() {
    const messagingChannelName = 'explore_messagingChannel';
    this.messagingChannel = postal.channel(messagingChannelName);
    // Initialize messagingTunnel to be used between iFrame and explore
    if (typeof window !== 'undefined') {
      window.messagingTunnel = channelName => postal.channel(channelName);
    }

    this.listeners = [
      this.messagingChannel.subscribe('routes.updated', this.updateRouteOrder),
      this.messagingChannel.subscribe('waypointsChanged', this.waypointsChanged),
      this.messagingChannel.subscribe('shareModal.open', data => this.openShareModal(data.shareObject)),
      this.messagingChannel.subscribe('listItem.added', ({ listItem }) =>
        this.props.listMethods.toggleListItem(listItem.listId, listItem.type, listItem.objectId)
      ),
      this.messagingChannel.subscribe('listItem.removed', ({ listItem }) =>
        this.props.listMethods.toggleListItem(listItem.listId, listItem.type, listItem.objectId)
      ),
      this.messagingChannel.subscribe('waypoint.updated', this.updateWaypoint),
      this.messagingChannel.subscribe('map.show', data => {
        this.showMapMobile(data ? data.replace : false);
      }),
      this.messagingChannel.subscribe('map.hide', data => {
        this.hideMapMobile(data ? data.replace : false);
      }),
      this.messagingChannel.subscribe('listModal.open', data => {
        this.props.listMethods.handleFavoriteClick(data.type, data.ID, data.objectID);
      }),
      this.messagingChannel.subscribe('trail.download.modal', data => this.openDownloadRouteModal(data.publishObject))
    ];
    this.revGeocodeRequest = null;
  },
  componentDidMount() {
    // If user is not logged in and is editing a recently created map, take them to Signup
    if (
      window &&
      !this.props.isAnonUsersNewMap &&
      this.props.initialPage === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE &&
      !this.props.context.currentUser &&
      this.props.initialSelectedObject &&
      this.props.initialSelectedObject.slug &&
      this.props.userInfo &&
      this.props.userInfo.slug === StringConstantsMixin.constants.MAGIC.ANONYMOUS_MAP_USERNAME
    ) {
      const url = window.checkLinkAndAppendLanguage(`/explore/map/${this.props.initialSelectedObject.slug}`);
      History.pushState(null, '', url);
      modalSignup('explore-map-new', url);
      return;
    }

    this.initAlgolia(this.props.context.primaryAlgoliaIndexId);

    // Bind state change to handlePopState
    History.internalChange = false;
    History.Adapter.bind(window, 'statechange', this.handlePopState);

    // Handle window resize events
    window.addEventListener('resize', this.handleResize);
    this.setupReviewModalListeners();

    let newFilterState = this.state.filters;

    // For "default" ip address of Pretty Prairie, Kansas, zoom-out of map and show the rest of the United States
    const initLocation = newFilterState.initLocationObject;
    if (initLocation && initLocation.slug === 'us/kansas/pretty-prairie') {
      this.refs.searchMap.setMapZoom(4);
    }

    // If we dont have an initial bounding box query
    // it means we are doing a map center + zoom level set
    // Grab the current map bounds to initialize the query
    // Only do this for expore all page since we want to fit markers for list pages
    if (this.state.filters.boundingBox == null && this.state.filters.queryTerm == null && this.state.page === PageStrings.EXPLORE_ALL_PAGE) {
      const newBounds = this.refs.searchMap.getMapBounds();
      newFilterState = SearchFiltersUtil.setBoundsFilter(newFilterState, newBounds[0], newBounds[2], newBounds[1], newBounds[3]);
    }

    // Mobile width must be set after the component has mounted, otherwise window does not exist in SSR
    const isMobileWidth = window && window.innerWidth <= 767;

    // If mobile map view should be turned on, turn on
    if (this.state.filters.mobileMap) {
      this.publishShowHideMap(isMobileWidth, this.state.filters.mobileMap, false);
    }

    // Update filters and isMobile state based on page type
    // Perform search after filtering if necessary
    if (this.state.page === PageStrings.EXPLORE_TRAIL_MAP_PAGE) {
      this.setState({ isMobileWidth });
      this.getSelectedTrailVerifiedMap(this.state.selectedObject.ID);
    } else if (
      [PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE, PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE, PageStrings.EXPLORE_LIFELINE_PAGE].includes(
        this.state.page
      )
    ) {
      // load lifeline data on component mount instead of before page render
      if (this.state.lifeline && this.state.lifeline.metadata.status === 'A') {
        this.checkLifelineStatusInterval = window.setInterval(() => {
          this.updateLifelineData();
        }, 60000);
      }
      this.setState({ filters: newFilterState, isMobileWidth });
    } else if ([PageStrings.EXPLORE_USERS_TRACKS_PAGE, PageStrings.EXPLORE_USERS_MAPS_PAGE].includes(this.state.page)) {
      if (!this.state.atMaps) {
        // load these recordings and maps on component mount instead of before page render
        const type = this.state.page === PageStrings.EXPLORE_USERS_MAPS_PAGE ? 'map' : 'track';
        this.getUserMaps(this.props.userInfo.id, type, true, true);
      }
      this.setState({ filters: newFilterState, isMobileWidth });
    } else {
      this.setState(
        {
          filters: newFilterState,
          isMobileWidth,
          // if we are in one of the explore list views, and there are no items in the current list, turn on Nearby Trails overlay
          nearbyTrailsShown: !!this.props.listId && !this.props.listMethods.hasItemsInList(this.props.listId, this.props.userListItems)
        },
        () => {
          this.replaceHistoryState();
          this.performSearch();
        }
      );
    }
  },
  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.props.updatePage(this.state.page);
    }

    /**
     *
     * This works with the result_card_mixin to update the filters when
     * a item is added or removed.
     *
     */
    if (this.props.listId && prevProps.latestListAction !== this.props.latestListAction && this.props.belongsToCurrentUser) {
      this.updateResultsFromListHash(this.props.latestListAction, this.props.userListItems);
    }

    /**
     *
     * Since the trail page is rendered out of an iframe we need to communicate with the TrailPage
     * when a list or listItems have changed.
     *
     */
    if (
      this.state.page === PageStrings.EXPLORE_TRAIL_MAP_PAGE &&
      (prevProps.listItems !== this.props.listItems || prevProps.lists !== this.props.lists)
    ) {
      this.messagingChannel.publish('lists.changed', { lists: this.props.lists, listItems: this.props.listItems });
    }
  },
  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.handleResize);
    }

    this.listeners.forEach(sub => {
      postal.unsubscribe(sub);
    });
  },
  setupReviewModalListeners() {
    window.document.addEventListener('openTrailFormModal', data =>
      this.openTrailFormModal(data.detail.activeTrailFormModal, data.detail.trailFormProps)
    );
  },
  blockNonUserCreation(type) {
    const returnToUrl = window.location.pathname + window.location.search;
    modalSignup(type, returnToUrl);
  },
  handleMapSaveSuccess(map) {
    this.updateExploreMap(map);
    $('#flash-msg').slideUp();
    this.updateProgressDialog('saved');
    // Bring user to signup page after saving
    if (!this.props.context.currentUser) {
      this.blockNonUserCreation('explore-map-new');
    }

    return map;
  },
  handleMapSaveError(err) {
    this.updateProgressDialog('error-saving');
    logError(err);
    return err;
  },
  renderProgressDialog() {
    if (!this.state.progressDialogState) {
      return null;
    }

    return ReactDOM.createPortal(
      <ProgressDialog variant={this.state.progressDialogState} updateProgressDialog={this.updateProgressDialog} />,
      document.getElementById('modalPortal')
    );
  },
  updateProgressDialog(progressDialogState) {
    this.setState({ progressDialogState });
  },
  saveMapChanges({ descriptionChangeset, waypoints = null }) {
    this.updateProgressDialog('saving');

    const panelData = {
      description: descriptionChangeset.description,
      name: descriptionChangeset.title,
      private: descriptionChangeset.isPrivate,
      createdAt: descriptionChangeset.date,
      activity: { uid: descriptionChangeset.activity.value }
    };

    if (this.props.context.featureFlags.flexiblePrivacy) {
      // we've got flexible privacy behind a featureflag at the moment, so we don't
      // want to send up the "private" boolean if we're included in the flexible privacy
      // feature flag.
      delete panelData.private;

      Object.assign(panelData, { contentPrivacy: descriptionChangeset.contentPrivacy });
    }

    if (waypoints) {
      Object.assign(panelData, { waypoints });
    }

    let mapData;
    // planner map only exists if a route has been drawn
    const plannerMap = this.state.routeInfo ? this.state.routeInfo.plannerMap : null;
    if (plannerMap && plannerMap.routes) {
      mapData = { ...plannerMap, ...panelData };
    } else {
      // if plannerMap is not there, we still need to save the bounds
      // TODO: using handleMapBoundsChanged, save `bounds`, `center`, `zoom`, etc. to SearchApp state
      // then use this for everything else (filters, etc.)
      // and reduce usage of this.refs.searchMap
      const [latitudeTopLeft, latitudeBottomRight, longitudeTopLeft, longitudeBottomRight] = this.refs.searchMap.getMapBounds();
      const bounds = { latitudeTopLeft, longitudeTopLeft, latitudeBottomRight, longitudeBottomRight };
      mapData = { bounds, presentationType: 'M', ...panelData };
    }

    if (isMapFaulty(mapData)) {
      alert(StringConstantsMixin.strings.TRACK_DETAIL.FINISH_DRAWING_ROUTE);
      this.updateProgressDialog('error-saving');
      return Promise.reject(new Error(`Map is faulty - ${JSON.toString(mapData)}`));
    }

    // Update Existing
    if (this.state.exploreMap.id) {
      mapData = { ...mapData, id: this.state.exploreMap.id };
      return updateAtMap(mapData)
        .then(this.handleMapSaveSuccess)
        .catch(this.handleMapSaveError);
    }

    // Save New
    return saveAtMap(mapData)
      .then(this.handleMapSaveSuccess)
      .catch(this.handleMapSaveError);
  },
  saveEditEndpointChanges({ segmentId, cropIndex, newEndPoint }) {
    this.updateProgressDialog('saving');
    return saveNewEndpoint(this.state.exploreMap.id, segmentId, cropIndex, newEndPoint)
      .then(map => {
        this.setState({ exploreMap: map });
      })
      .catch(e => {
        this.updateProgressDialog('error-saving');
        return e;
      })
      .finally(() => {
        this.updateProgressDialog(null);
      });
  },
  handleRouteInfoChanged(routeInfoChanges) {
    if (!routeInfoChanges) {
      this.setState({ routeInfo: null });
      return;
    }
    let { routeInfo } = this.state;
    routeInfo = routeInfo ? { ...routeInfo, ...routeInfoChanges } : routeInfoChanges;
    this.setState({ routeInfo });
  },
  updateRouteOrder(data) {
    this.setState({ exploreMap: { ...this.state.exploreMap, routes: data } });
  },
  updateExploreMap(map) {
    const previousId = this.state.exploreMap.id || null;
    this.setState({ exploreMap: { ...this.state.exploreMap, ...map, routes: map.routes, waypoints: map.waypoints }, selectedObject: map }, () => {
      if (!previousId && this.state.exploreMap.id) {
        const url = window.checkLinkAndAppendLanguage(`/explore/map/${this.state.exploreMap.slug}`);
        History.internalChange = true;
        History.pushState(
          { page: PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE, selectedObjectId: this.state.exploreMap.ID, filters: null },
          `Explore ${this.state.exploreMap.name} | AllTrails`,
          url
        );
      }
    });
  },
  waypointsChanged(data) {
    let { waypoints } = data;
    const { editWaypointId, activeWaypoint } = data;

    // if a waypoint is new and doesn't have a lat / lng, we want to coordinate it with the map
    if (typeof activeWaypoint !== 'undefined' && activeWaypoint.location.longitude === null && activeWaypoint.location.latitude === null) {
      const [latitude, longitude] = this.refs.searchMap.getMapCenter();
      waypoints = waypoints.map(wp => {
        if (wp.id === null) {
          return { ...wp, location: { longitude, latitude } };
        }

        return wp;
      });
      this.messagingChannel.publish('waypoint.dragged.with_location', { waypointId: activeWaypoint.id, location: { latitude, longitude } });
    }

    this.setState({ exploreMap: { ...this.state.exploreMap, waypoints, editWaypointId } });
  },
  newSearchFilters() {
    const page = this.state && this.state.page ? this.state.page : this.props.initialPage;
    return SearchFiltersUtil.getSearchFilters(this.props.context, page, this.props.initialUserSlug);
  },
  showMapMobile(replace) {
    if (typeof $ !== 'undefined') {
      $('#fullscreen-search-results')
        .css('height', 'fit-content')
        .css('z-index', 2)
        .css('padding-bottom', '0');
      $('.count-container').css('display', 'none');
      $('#fullscreen-search-results>ul').css('display', 'none');
      $('#fullscreen-track-details').css('display', 'none');
      $('#fullscreen-search-map').css('visibility', 'visible');
      // scroll to top of page
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
    const { filters } = this.state;
    if (!filters.mobileMap) {
      filters.mobileMap = true;
      this.setState({ filters }, replace ? this.replaceHistoryState : this.pushHistoryStateAndSearch);
    }
  },
  hideMapMobile() {
    $('#fullscreen-search-results')
      .css('height', '')
      .css('padding-bottom', '');
    $('.count-container').css('display', 'flex');
    $('#fullscreen-search-results>ul').css('display', 'block');
    $('#fullscreen-track-details').css('display', 'block');
    $('#fullscreen-search-map').css('visibility', '');
    // scroll to top of page
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const { filters } = this.state;
    if (filters.mobileMap) {
      filters.mobileMap = false;
      this.setState({ filters }, this.pushHistoryStateAndSearch);
    }
  },
  publishShowHideMap(isMobileWidth, mobileMap, replace) {
    if (isMobileWidth && mobileMap) {
      this.messagingChannel.publish('map.show', { replace });
    } else {
      this.messagingChannel.publish('map.hide', { replace });
    }
  },
  handlePopState() {
    if (History.internalChange) {
      History.internalChange = false;
      return;
    }

    const prevState = History.getState();
    let newFilters = prevState.data.filters;
    const newPage = prevState.data.page;
    if (!newPage) {
      return;
    }

    if (newPage === PageStrings.EXPLORE_ALL_PAGE && this.refs.searchMap) {
      this.messagingChannel.publish({
        topic: 'edit.disable_trail_planner'
      });
    }

    if (newFilters && this.state.filters && newFilters.mobileMap !== this.state.filters.mobileMap) {
      this.publishShowHideMap(this.state.isMobileWidth, newFilters.mobileMap, false);
    }

    if (newFilters && newFilters.boundingBox && newFilters.boundingBox.latitudeTopLeft && !this.state.isMobileWidth) {
      this.refs.searchMap.setMapBounds(newFilters.boundingBox);
    }

    if (!newFilters) {
      newFilters = this.newSearchFilters();
    }

    if ([PageStrings.EXPLORE_CUSTOM_PAGE, PageStrings.EXPLORE_COMPLETED_PAGE, PageStrings.EXPLORE_FAVORITE_PAGE].includes(newPage)) {
      newFilters = SearchFiltersUtil.setFilter(newFilters, 'trailIds', this.state.filters.trailIds);
      newFilters = SearchFiltersUtil.setFilter(newFilters, 'trackIds', this.state.filters.trackIds);
      newFilters = SearchFiltersUtil.setFilter(newFilters, 'mapIds', this.state.filters.mapIds);
      this.setState(
        { page: newPage, filters: newFilters, trackTrail: null, exploreMap: null, results: [], selectedObject: null },
        this.performSearch
      );
    } else if (newPage === PageStrings.EXPLORE_TRAIL_MAP_PAGE) {
      this.setState({ page: newPage, results: [] }, this.getAlgoliaTrail(prevState.data.selectedObjectId));
      this.getSelectedTrailVerifiedMap(prevState.data.selectedObjectId);
    } else if ([PageStrings.EXPLORE_USERS_TRACKS_PAGE, PageStrings.EXPLORE_USERS_MAPS_PAGE].includes(newPage)) {
      this.setState(
        { page: newPage, filters: newFilters, trackTrail: null, selectedObject: null, results: [], exploreMap: null },
        this.performSearch
      );
    } else if (
      [PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE, PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE, PageStrings.EXPLORE_LIFELINE_PAGE].includes(newPage)
    ) {
      const selectedObject = this.state.atMaps.filter(atMap => {
        return atMap.ID == prevState.data.selectedObjectId;
      })[0];
      this.setState({ page: newPage, selectedObject, results: [], filters: newFilters });
      this.getSelectedTrackDetails(prevState.data.selectedObjectId);
    } else {
      this.setState({ filters: newFilters, page: newPage, exploreMap: null, selectedObject: null }, this.performSearch);
    }
  },
  updateLifelineData() {
    ServerCommunicationUtil.getApiEndpoint(
      `/api/alltrails/lifeline/sessions/${this.state.lifeline.id}`,
      { detail: 'web' },
      data => {
        if (data && data.sessions) {
          const session = data.sessions[0];
          if (session.metadata.status === LIFELINE_STATUS_SAFE) {
            window.clearInterval(this.checkLifelineStatusInterval);
          }
          // maintain the zoom and bounds that the user is currently using
          let allFilters = this.newSearchFilters();
          const currentBounds = this.refs.searchMap.getMapBounds();
          allFilters = SearchFiltersUtil.setBoundsFilter(allFilters, currentBounds[0], currentBounds[2], currentBounds[1], currentBounds[3]);
          allFilters = SearchFiltersUtil.setFilter(allFilters, 'zoomLevel', this.refs.searchMap.getMapZoom());
          this.setState({ lifeline: session, filters: allFilters });
        }
      },
      err => {
        console.log(err);
      },
      () => {}
    );
  },
  handleResize() {
    const oldIsMobileWidth = this.state.isMobileWidth;
    const isMobileWidth = typeof window !== 'undefined' && window.innerWidth <= 767;
    if (isMobileWidth != oldIsMobileWidth) {
      this.setState({ isMobileWidth });
      if (this.state.filters) {
        this.publishShowHideMap(isMobileWidth, this.state.filters.mobileMap, true);
      }
    }
  },
  handleFilterToggle(filterType, filterToToggle) {
    this.handleFilterChange(SearchFiltersUtil.toggleFilter, filterType, filterToToggle);
  },
  handleFilterSlider(filterType, sliderValues) {
    this.handleFilterChange(SearchFiltersUtil.sliderFilter, filterType, sliderValues);
  },
  handleFilterSet(filterType, value) {
    this.handleFilterChange(SearchFiltersUtil.setFilter, filterType, value);
  },
  handleSortFilterClick(sortFilterName) {
    const newFilterState = SearchFiltersUtil.toggleSortFilter(this.state.filters, sortFilterName);
    this.setState({ filters: newFilterState, searchTrigger: FILTER }, this.replaceHistoryStateAndSearch);
  },
  handleFilterChange(updateFunc, filterType, newValue) {
    const newFilterState = updateFunc(this.state.filters, filterType, newValue);
    this.setState({ filters: newFilterState, searchTrigger: FILTER }, this.replaceHistoryStateAndSearch);
  },
  handleQueryTermSet(value) {
    // When we query on a term we dont want a bounding box, so set it to null
    let newFilterState = SearchFiltersUtil.setFilter(this.state.filters, 'queryTerm', value);
    newFilterState = SearchFiltersUtil.setFilter(newFilterState, 'locationObject', null);
    newFilterState = SearchFiltersUtil.setFilter(newFilterState, 'boundingBox', null);
    this.setState({ filters: newFilterState }, this.replaceHistoryStateAndSearch);
  },
  handleReverseGeocode(lat, lng) {
    const revGeocodeUrl = '/api/alltrails/locations/reverse_geocode';
    const successFunc = data => {
      this.revGeocodeRequest = null;
      let { titleString } = this.state;
      if (data && data.name) {
        titleString = `${StringConstantsMixin.strings.SEARCH.MAP_OF_TRAILS_NEAR} ${data.name}`;
      }
      const newFilterState = SearchFiltersUtil.setFilter(this.state.filters, 'locationObject', data === 'null' ? null : data);
      this.setState({ filters: newFilterState, titleString }, this.replaceHistoryState);
    };
    const errorFunc = () => {
      let newFilterState = this.state.filters;
      newFilterState = SearchFiltersUtil.setFilter(newFilterState, 'locationObject', null);
      this.setState({ filters: newFilterState });
    };
    const completeFunc = () => {};
    if (this.revGeocodeRequest) {
      this.revGeocodeRequest.abort();
      this.revGeocodeRequest = null;
    }
    this.revGeocodeRequest = ServerCommunicationUtil.postApiEndpoint(
      revGeocodeUrl,
      { latitude: lat, longitude: lng },
      successFunc,
      errorFunc,
      completeFunc
    );
  },
  clearAllFilters() {
    let newFilterState = this.newSearchFilters();
    const state = {};

    // Keep search bounding box when clearing if on EXPLORE ALL Page
    if (this.state.page === PageStrings.EXPLORE_ALL_PAGE) {
      newFilterState.boundingBox = this.state.filters.boundingBox;
    } else if (
      this.state.page === PageStrings.EXPLORE_CUSTOM_PAGE ||
      this.state.page === PageStrings.EXPLORE_FAVORITE_PAGE ||
      this.state.page === PageStrings.EXPLORE_COMPLETED_PAGE
    ) {
      // Keep current bounds if results are present, but clear all other filters
      if (this.state.results && this.state.results.length > 0) {
        newFilterState.boundingBox = this.state.filters.boundingBox;
      }
      // Only add back in trailIds if they exist
      const trailIds = this.state.filters.trailIds;
      const trackIds = this.state.filters.trackIds;
      const mapIds = this.state.filters.mapIds;
      if ((trailIds && trailIds.length > 0) || (trackIds && trackIds.length > 0) || (mapIds && mapIds.length > 0)) {
        newFilterState = SearchFiltersUtil.setFilter(newFilterState, 'trailIds', this.state.filters.trailIds);
        newFilterState = SearchFiltersUtil.setFilter(newFilterState, 'trackIds', this.state.filters.trackIds);
        newFilterState = SearchFiltersUtil.setFilter(newFilterState, 'mapIds', this.state.filters.mapIds);
      } else {
        // Force the no result state to be searching for trails...
        state.results = null;
      }
    } else if (this.state.page === PageStrings.EXPLORE_USERS_TRACKS_PAGE || this.state.page === PageStrings.EXPLORE_USERS_MAPS_PAGE) {
      // Keep current bounds if results are present, but clear all other filters
      if (this.state.results && this.state.results.length > 0) {
        newFilterState.boundingBox = this.state.filters.boundingBox;
      }
      if (this.state.atMaps == null || (this.state.atMaps && this.state.atMaps.length === 0)) {
        state.page = PageStrings.EXPLORE_ALL_PAGE;
        // Force the no result state to be searching for trails...
        state.results = null;
      }
    }

    state.filters = newFilterState;
    state.searchTrigger = FILTER;
    this.setState(state, this.replaceHistoryStateAndSearch);
  },
  handleMapBoundsChanged(newCenter, newBounds, newZoomLevel) {
    // Clear the algolia cache to help with memory limits
    if (this.algoliaRef) {
      this.algoliaRef.clearCache();
    }
    // If we're in trail details, dont do anything for mapmoves
    if (
      this.state.page === PageStrings.EXPLORE_TRAIL_MAP_PAGE ||
      this.state.page === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE ||
      this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE ||
      this.state.page === PageStrings.EXPLORE_LIFELINE_PAGE ||
      this.state.isEditing
    ) {
      return;
    }
    if (this.state.page === PageStrings.EXPLORE_ALL_PAGE) {
      if (this.geocodeTimeout) {
        clearInterval(this.geocodeTimeout);
      }
      this.geocodeTimeout = setTimeout(() => {
        this.handleReverseGeocode(newCenter[0], newCenter[1]);
      }, 1000);
    }
    let newFilterState = SearchFiltersUtil.setBoundsFilter(this.state.filters, newBounds[0], newBounds[2], newBounds[1], newBounds[3]);
    newFilterState = SearchFiltersUtil.setFilter(newFilterState, 'locationObject', null);
    newFilterState = SearchFiltersUtil.setZoomLevelFilter(newFilterState, newZoomLevel);
    // On initial load, call pushHistoryState to ensure that "back buttons" will give expected behavior after clicking into a trail
    // Update filters without calling setState to prevent unnecessary render before search results are retrieved
    this.state.filters = newFilterState;
    this.state.searchTrigger = MAP_PAN;
    this.replaceHistoryStateAndSearch();
  },
  replaceHistoryState() {
    History.internalChange = true;
    const titleString =
      this.state.titleString === '' && this.props.initialHTMLTitleString ? this.props.initialHTMLTitleString : this.state.titleString;

    if (this.state.selectedObject)
      History.replaceState(
        { filters: this.state.filters, page: this.state.page, selectedObjectId: this.state.selectedObject.ID },
        `${titleString} | AllTrails`,
        SearchFiltersUtil.createUrlFromPageAndFilters(this.state.page, this.state.filters, this.state.selectedObject)
      );
    else
      History.replaceState(
        { filters: this.state.filters, page: this.state.page },
        `${titleString} | AllTrails`,
        SearchFiltersUtil.createUrlFromPageAndFilters(this.state.page, this.state.filters, this.state.selectedObject)
      );
  },
  replaceHistoryStateAndSearch() {
    this.replaceHistoryState();
    this.performSearch();
  },
  pushHistoryStateAndSearch() {
    History.internalChange = true;
    const titleString =
      this.state.titleString === '' && this.props.initialHTMLTitleString ? this.props.initialHTMLTitleString : this.state.titleString;
    if (this.state.selectedObject)
      History.pushState(
        { filters: this.state.filters, page: this.state.page, selectedObjectId: this.state.selectedObject.ID },
        `${titleString} | AllTrails`,
        SearchFiltersUtil.createUrlFromPageAndFilters(this.state.page, this.state.filters, this.state.selectedObject)
      );
    else
      History.pushState(
        { filters: this.state.filters, page: this.state.page },
        `${titleString} | AllTrails`,
        SearchFiltersUtil.createUrlFromPageAndFilters(this.state.page, this.state.filters, this.state.selectedObject)
      );
    this.performSearch();
  },
  toggleNearbyTrailsOverlay(e) {
    this.refs.searchMap.toggleOverlay('nearbyTrails');
    this.setState({ nearbyTrailsShown: !this.state.nearbyTrailsShown });
  },
  getSelectedTrailVerifiedMap(trailId) {
    loadVerifiedRoute(trailId)
      .then(exploreMap => {
        this.setState({ exploreMap });
      })
      .catch(e => {
        logError(e);
        // If it is discovered that the trail has been replaced by another (such as through a merge),
        // then completely refresh the page
        if (e.responseText?.includes(`${trailId} replaced by`)) {
          window.location.reload();
        }
      });
  },
  goToTrailPage(trail) {
    const { localizedUrl } = getFormattedTrailUrls(trail, this.props.context);
    window.location.href = localizedUrl;
  },
  navigateToExploreTrail(trail) {
    History.internalChange = true;
    let url = this.formatTrailUrl(trail);
    // Append the user's units if they differ from the object's own native units
    if (this.props.context.currentUser && trail.units) {
      if (this.props.context.currentUser.metric && trail.units != 'm') {
        url += '?u=m';
      } else if (!this.props.context.currentUser.metric && trail.units != 'i') {
        url += '?u=i';
      }
    }
    History.pushState({ page: PageStrings.EXPLORE_TRAIL_MAP_PAGE, selectedObjectId: trail.ID }, `Explore ${trail.name} | AllTrails`, url);
    const newFilters = this.state.filters;
    let backReturnsToExplore = false;
    // If we get to a trail from TRACK MAP PAGE, we want backToExplore to go back to explore all, so set backReturnsToExplore
    if (this.state.page === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE) {
      backReturnsToExplore = true;
    }
    this.setState(
      {
        filters: newFilters,
        selectedObject: trail,
        page: PageStrings.EXPLORE_TRAIL_MAP_PAGE,
        exploreMap: null,
        backReturnsToExplore,
        numberViewedTrails: this.state.numberViewedTrails + 1
      },
      this.getSelectedTrailVerifiedMap(trail.ID)
    );
  },
  handleTrailClick(trail) {
    if (this.state.selectedObject && this.state.page === PageStrings.EXPLORE_TRAIL_MAP_PAGE && trail.ID == this.state.selectedObject.ID) {
      return;
    }
    if (this.props.context.mobileBrowser || this.state.isMobileWidth) {
      this.goToTrailPage(trail);
      return;
    }
    if (this.props.context.currentUser) {
      // Logged in, allow access to exploreMaps
      this.navigateToExploreTrail(trail);
    } else {
      // If Not mobile and NotLogged in, dont show free maps
      if (this.state.numberViewedTrails < MAX_ALLOWED_EXPLORE_TRAIL_COUNT) {
        this.navigateToExploreTrail(trail);
      } else {
        // NOTE: We navigate to the data url as the back end will handle the signup
        // redirect logic as well as number of allowed trails setting
        window.location = this.formatTrailUrl(trail);
      }
      return;
    }
    this.messagingChannel.publish('edit.disable_trail_planner');
  },
  // formats trail url for trail result cards and hover cards
  formatTrailUrl(trail) {
    return getFormattedTrailUrls(trail, this.props.context, 'explore').localizedUrl;
  },
  setBackReturnsToExplore(backReturnsToExplore) {
    this.setState({ backReturnsToExplore });
  },
  getSelectedTrackDetails(trackId) {
    $.ajax({
      url: `/api/alltrails/maps/${trackId}?detail=deep&combine_segments=false`,
      headers: {
        'X-AT-KEY': ServerCommunicationUtil.apiKey,
        'X-Language-Locale': this.props.context.languageRegionCode
      },
      success: data => {
        const exploreMap = data.maps[0];
        if (exploreMap.trailId) {
          this.getAlgoliaTrail(exploreMap.trailId);
        }
        if (exploreMap) {
          this.setState({ exploreMap: { ID: trackId, ...exploreMap } });
        }
      }
    });
  },
  setMaps(maps, revertBounds, performSearchAfterLoad) {
    // remove any maps that came back malformed
    const formattedMaps = maps.filter(map => !!map._geoloc);
    const newState = { atMaps: formattedMaps, results: formattedMaps, loading: false };
    let afterLoad;
    if (performSearchAfterLoad) {
      afterLoad = this.replaceHistoryStateAndSearch;
      // we may want to reset the bounds here to include all the pins
      if (revertBounds) {
        const { filters } = this.state;
        filters.boundingBox = null;
        newState.filters = filters;
      }
    }
    this.setState(newState, afterLoad);
  },
  getUserMaps(userId, presentationType, performSearchAfterLoad, revertBounds) {
    if (presentationType !== 'map' && presentationType !== 'track') return;

    let mapsUrl;
    if (this.props.context.currentUser && userId == this.props.context.currentUser.id) {
      mapsUrl = `/api/alltrails/my/maps?presentation_type=${presentationType}&detail=algolia`;
    } else {
      const allowPrivate = this.props.context.adminUser ? '&allow_private=true' : '';
      mapsUrl = `/api/alltrails/users/${userId}/maps?presentation_type=${presentationType}&detail=algolia${allowPrivate}`;
    }

    ServerCommunicationUtil.getApiEndpoint(
      mapsUrl,
      {},
      data => {
        this.setMaps(data.maps, revertBounds, performSearchAfterLoad);
      },
      () => {
        alert('an error occurred, please contact support@alltrails.com if it persists.');
      },
      () => {}
    );
  },
  handleTrackClick(track, idx) {
    if (this.state.selectedObject && this.state.exploreMap.id == track.ID) {
      return;
    }
    if (this.state.page === PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE) {
      logCommunityContentItemClicked(track, idx);
    }
    this.getSelectedTrackDetails(track.ID);
    History.internalChange = true;
    let url = `/explore/recording/${track.slug}`;
    // Append the user's units if they differ from the object's own native units
    if (this.props.context.currentUser && track.units) {
      if (this.props.context.currentUser.metric && track.units !== 'm') url += '?u=m';
      else if (!this.props.context.currentUser.metric && track.units !== 'i') url += '?u=i';
    }
    url = window.checkLinkAndAppendLanguage(url);
    History.pushState(
      { page: PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE, selectedObjectId: track.ID, filters: null },
      `Explore ${track.name} | AllTrails`,
      url
    );
    this.setState({ page: PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE, selectedObject: track });
  },
  handleMapClick(map) {
    if (this.state.selectedObject && this.state.exploreMap.id == map.ID) {
      return;
    }
    this.getSelectedTrackDetails(map.ID);
    const url = window.checkLinkAndAppendLanguage(`/explore/map/${map.slug}`);
    History.internalChange = true;
    History.pushState(
      { page: PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE, selectedObjectId: map.ID, filters: null },
      `Explore ${map.name} | AllTrails`,
      url
    );
    this.setState({ page: PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE, selectedObject: map });
  },
  addWaypoint(waypoint) {
    const { exploreMap } = this.state;
    const waypoints = exploreMap.waypoints.slice();
    waypoints.push(waypoint);
    this.setState({ exploreMap: { ...exploreMap, waypoints, editWaypointId: null } });
  },
  removeWaypoint(waypoint) {
    const { exploreMap } = this.state;
    const waypoints = exploreMap.waypoints.filter(wp => wp.id !== waypoint.id);
    this.setState({ exploreMap: { ...exploreMap, waypoints, editWaypointId: null } });
  },
  updateWaypoint(waypoint) {
    const { exploreMap } = this.state;
    const waypoints = exploreMap.waypoints.map(wp => (waypoint.id === wp.id ? waypoint : wp));
    this.setState({ exploreMap: { ...exploreMap, waypoints, editWaypointId: null } });
  },
  handleMapUpdate(map) {
    this.getSelectedTrackDetails(map.id);
  },
  handleMapCreate(map) {
    if (
      (this.props.context.currentUser &&
        (this.state.page === PageStrings.EXPLORE_USERS_MAPS_PAGE || this.state.page === PageStrings.EXPLORE_USERS_TRACKS_PAGE) &&
        map.user &&
        map.user.slug !== this.props.context.currentUser.slug) ||
      (this.state.exploreMap &&
        this.state.exploreMap.user &&
        this.props.context.currentUser &&
        this.state.exploreMap.user.id != this.props.context.currentUser.id)
    ) {
      window.location = window.checkLinkAndAppendLanguage(`/explore/map/${map.slug}`);
      return;
    }
    map.ID = map.id;
    map.type = 'map';
    // this.getSelectedTrackDetails(map.ID);
    if (map.trailId) this.getAlgoliaTrail(map.trailId);
    // Get all the maps for the user so that Explore More maps works;
    this.getUserMaps(map.user.id, 'map');
    const url = window.checkLinkAndAppendLanguage(`/explore/map/${map.slug}`);
    History.internalChange = true;
    History.pushState(
      { page: PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE, selectedObjectId: map.ID, filters: null },
      `Explore ${map.name} | AllTrails`,
      url
    );
    this.setState({
      page: PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE,
      selectedObject: map,
      exploreMap: map,
      titleString: StringConstantsMixin.strings.MY_MAPS
    });
  },
  handleNewMapClick() {
    window.location = '/explore/map/new';
  },
  handleRecordingRequest({ detail }) {
    const recording = detail;
    recording.ID = recording.id;
    // this.getSelectedTrackDetails(map.ID);
    if (recording.trailId) this.getAlgoliaTrail(recording.trailId);
    // Get all the recording for the user so that Explore More recording works;
    this.getUserMaps(recording.user.id, 'track');
    const url = window.checkLinkAndAppendLanguage(`/explore/recording/${recording.slug}`);
    History.internalChange = true;
    History.pushState(
      { page: PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE, selectedObjectId: recording.ID, filters: null },
      `Explore ${recording.name} | AllTrails`,
      url
    );
    this.setState({
      page: PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE,
      selectedObject: recording,
      exploreMap: recording,
      titleString: StringConstantsMixin.strings.MY_RECORDINGS
    });
  },
  updateEditingStatus(editing) {
    const isListOwner = this.props.belongsToCurrentUser;

    if (!isListOwner) {
      return;
    }

    if (editing) {
      // if toggling edit on, zoom out map to see all results
      const newFilterState = this.newSearchFilters();

      const updatedFilterState = SearchFiltersUtil.setFilter(newFilterState, 'trailIds', this.state.filters.trailIds);
      this.setState({ isEditing: editing, filters: updatedFilterState }, this.replaceHistoryStateAndSearch);
    } else {
      this.setState({ isEditing: editing });
      // if toggling edit off, save list order
      if (this.props.listId) {
        this.handleListReordering();
      }
    }
  },
  backToExplore() {
    this.messagingChannel.publish('map.edit-endpoint-state-changed', { editingEndpoint: false, canceled: true });
    this.messagingChannel.publish('edit.disable_trail_planner');
    let allFilters = this.newSearchFilters();
    const prevHistory = History.getStateByIndex(History.savedStates.length - 2);
    // If we're on a track show page, we should always go back to explore recordings with explore more recordings button
    if (this.state.page === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE) {
      // Just "go back" when viewing community content
      if (prevHistory && prevHistory.data && prevHistory.data.page === PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE) {
        History.back();
      }
      const currentSearchBounds = this.state.filters.boundingBox;
      // If we have search bounds set, go back to these bounds
      if (currentSearchBounds && currentSearchBounds.latitudeTopLeft) {
        allFilters = SearchFiltersUtil.setBoundsFilter(
          allFilters,
          currentSearchBounds.latitudeTopLeft,
          currentSearchBounds.longitudeTopLeft,
          currentSearchBounds.latitudeBottomRight,
          currentSearchBounds.longitudeBottomRight
        );
        this.refs.searchMap.setMapBounds(currentSearchBounds);
        allFilters = SearchFiltersUtil.setFilter(allFilters, 'zoomLevel', this.refs.searchMap.getMapZoom());
      }
      // Othwerise just go back with NULL bounds so we can fit all the markers on the map
      const { atMaps } = this.state;
      if (!atMaps && this.props.initialUserSlug != ET_PHOTO_USER_SLUG) {
        // Allow for the getUserMaps call to run before trying to pushHistoryStateAndSearch
        this.getUserMaps(this.state.exploreMap.user.id, 'track', true);
        this.setState({
          filters: allFilters,
          results: null,
          trackTrail: null,
          atMaps,
          selectedObject: null,
          exploreMap: null,
          page: PageStrings.EXPLORE_USERS_TRACKS_PAGE,
          titleString: this.props.initialTitleString
        });
      } else {
        this.setState(
          {
            filters: allFilters,
            results: null,
            trackTrail: null,
            atMaps,
            selectedObject: null,
            exploreMap: null,
            page: PageStrings.EXPLORE_USERS_TRACKS_PAGE,
            titleString: this.props.initialTitleString
          },
          this.pushHistoryStateAndSearch
        );
      }
    }
    if (this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE) {
      // Just "go back" when viewing community content
      if (prevHistory && prevHistory.data && prevHistory.data.page === PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE) {
        History.back();
      }
      const currentSearchBounds = this.state.filters.boundingBox;
      // If we have search bounds set, go back to these bounds
      if (currentSearchBounds && currentSearchBounds.latitudeTopLeft) {
        allFilters = SearchFiltersUtil.setBoundsFilter(
          allFilters,
          currentSearchBounds.latitudeTopLeft,
          currentSearchBounds.longitudeTopLeft,
          currentSearchBounds.latitudeBottomRight,
          currentSearchBounds.longitudeBottomRight
        );
        this.refs.searchMap.setMapBounds(currentSearchBounds);
        const zoomLevel = this.refs.searchMap.getMapZoom();
        allFilters = SearchFiltersUtil.setZoomLevelFilter(allFilters, zoomLevel);
      }
      const { atMaps } = this.state;
      if (!atMaps) {
        this.getUserMaps(this.state.exploreMap.user.id, 'map', true);
        this.setState({
          filters: allFilters,
          results: [],
          selectedObject: null,
          exploreMap: null,
          trackTrail: null,
          atMaps,
          page: PageStrings.EXPLORE_USERS_MAPS_PAGE,
          titleString: this.props.initialTitleString
        });
      } else {
        // Othwerise just go back with NULL bounds so we can fit all the markers on the map
        this.setState(
          {
            filters: allFilters,
            results: [],
            selectedObject: null,
            exploreMap: null,
            trackTrail: null,
            atMaps,
            page: PageStrings.EXPLORE_USERS_MAPS_PAGE,
            titleString: this.props.initialTitleString
          },
          this.pushHistoryStateAndSearch
        );
      }
    }
    // If on a trail show page
    else if (this.state.page === PageStrings.EXPLORE_TRAIL_MAP_PAGE) {
      // If we have trailIds we had to have come from a list, so just go back
      if (this.state.filters.trailIds && this.state.filters.trailIds.length > 0) {
        History.back();
      } else {
        const currentSearchBounds = this.state.filters.boundingBox;
        // If no search bounds, zoom out a bit and then go to Explore All
        if (currentSearchBounds == null || this.state.backReturnsToExplore) {
          const mapCenter = this.refs.searchMap.getMapCenter();
          this.refs.searchMap.setMapCenterAndZoom(mapCenter[0], mapCenter[1], 14, { suppressBoundsCallback: true });
          const newBounds = this.refs.searchMap.getMapBounds();
          allFilters = SearchFiltersUtil.setBoundsFilter(allFilters, newBounds[0], newBounds[2], newBounds[1], newBounds[3]);
          allFilters = SearchFiltersUtil.setFilter(allFilters, 'zoomLevel', this.refs.searchMap.getMapZoom());
          this.setState(
            {
              filters: allFilters,
              results: [],
              selectedObject: null,
              exploreMap: null,
              page: PageStrings.EXPLORE_ALL_PAGE,
              backReturnsToExplore: false,
              titleString: 'Explore'
            },
            this.pushHistoryStateAndSearch
          );
          // Otherwise, just use back
        } else {
          History.back();
        }
      }
    }
  },
  handleTrackPhotosUpload(photos) {
    const currentMap = this.state.exploreMap;
    if (currentMap.mapPhotos && currentMap.mapPhotos.length === 0) {
      const forceTrackPhotoIds = this.state.forceTrackPhotoIds || {};
      forceTrackPhotoIds[this.state.exploreMap.id] = photos[0].photo.id;
      this.setState({ forceTrackPhotoIds });
    }
    currentMap.mapPhotos = currentMap.mapPhotos.concat(photos);
    this.setState({ exploreMap: currentMap });
  },
  changeParentResultOrder(newResults, newTrailFilterIds) {
    let newFilters = this.newSearchFilters();
    newFilters = SearchFiltersUtil.setFilter(newFilters, 'trailIds', newTrailFilterIds);
    this.setState({ results: newResults, filters: newFilters });
  },
  handleTrackDefaultPhotoChanged(photoId) {
    const forceTrackPhotoIds = this.state.forceTrackPhotoIds || {};
    forceTrackPhotoIds[this.state.exploreMap.id] = photoId;
    this.setState({ forceTrackPhotoIds });
  },
  handleMapInfoChanged(newMap) {
    if (!newMap) {
      return;
    }
    if (newMap?.maps) {
      newMap = newMap.maps[0];
    }
    if (newMap?.map) {
      newMap = newMap.map;
    }
    this.setState({ exploreMap: newMap });
  },
  handleOverlayToggled(overlay) {
    if (overlay === 'nearbyTrails') {
      this.setState({ nearbyTrailsShown: !this.state.nearbyTrailsShown });
    }
  },
  getMapViewCenter() {
    const center = this.refs.searchMap.getMapCenter();
    return { latitude: center[0].toFixed(5), longitude: center[1].toFixed(5) };
  },
  enablePlaceFilters(enabledFilters) {
    const index = enabledFilters.indexOf('access') + 1;
    enabledFilters.splice(index, 0, 'city', 'state', 'country');
  },
  renderFilterBar() {
    let enabledFilters = [];
    let searchBoxTypeSubsets = [];
    let placeholderText;
    let breadcrumbItems = [];
    switch (this.state.page) {
      case PageStrings.EXPLORE_FAVORITE_PAGE:
        placeholderText = StringConstantsMixin.strings.SEARCH.SEARCH_FAVORITE_TRAILS;
        enabledFilters = ['difficulty', 'length', 'rating', 'activity', 'feature', 'access', 'area', 'route_type', 'visitor_usage', 'elevation_gain'];
        if (this.props.context.currentUser) {
          enabledFilters.push('completed');
        }
        if (this.props.context.adminUser) {
          this.enablePlaceFilters(enabledFilters);
        }
        searchBoxTypeSubsets = ['all', 'area', 'place', 'trail', 'track', 'map', 'list'];
        break;
      case PageStrings.EXPLORE_COMPLETED_PAGE:
        placeholderText = StringConstantsMixin.strings.SEARCH.SEARCH_COMPLETED_TRAILS;
        enabledFilters = ['difficulty', 'length', 'rating', 'activity', 'feature', 'access', 'area', 'route_type', 'visitor_usage', 'elevation_gain'];
        if (this.props.context.currentUser) {
          enabledFilters.push('completed');
        }
        if (this.props.context.adminUser) {
          this.enablePlaceFilters(enabledFilters);
        }
        searchBoxTypeSubsets = ['all', 'area', 'place', 'trail', 'track', 'map', 'list'];
        break;
      case PageStrings.EXPLORE_ALL_PAGE:
        placeholderText = this.state.filters.locationObject
          ? LanguageSupportUtil.findRecordFieldWithLocale(this.state.filters.locationObject, 'name', this.props.context.languageRegionCode)
          : '';
        enabledFilters = [
          'sort',
          'difficulty',
          'length',
          'rating',
          'activity',
          'feature',
          'access',
          'area',
          'route_type',
          'visitor_usage',
          'elevation_gain',
          'time_duration'
        ];
        if (this.props.context.currentUser) {
          enabledFilters.push('completed');
        }
        if (this.props.context.adminUser) {
          this.enablePlaceFilters(enabledFilters);
        }
        searchBoxTypeSubsets = ['all', 'area', 'place', 'trail', 'track', 'map', 'list'];
        break;
      case PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE:
        placeholderText = this.state.filters.locationObject
          ? LanguageSupportUtil.findRecordFieldWithLocale(this.state.filters.locationObject.name, 'name', this.props.context.languageRegionCode)
          : '';
        enabledFilters = ['length', 'rating', 'activity', 'elevation_gain'];
        if (this.props.context.adminUser) {
          enabledFilters.push('place');
        }
        searchBoxTypeSubsets = ['all', 'area', 'place', 'trail', 'track', 'map', 'list'];
        break;
      case PageStrings.EXPLORE_CUSTOM_PAGE:
        enabledFilters = [
          'sort',
          'difficulty',
          'length',
          'rating',
          'activity',
          'feature',
          'access',
          'area',
          'route_type',
          'visitor_usage',
          'elevation_gain'
        ];
        if (this.props.context.currentUser) {
          enabledFilters.push('completed');
        }
        if (this.props.context.adminUser) {
          this.enablePlaceFilters(enabledFilters);
        }
        searchBoxTypeSubsets = ['all', 'area', 'place', 'trail', 'track', 'map', 'list'];
        placeholderText = StringConstantsMixin.strings.SEARCH.SEARCH_LIST;
        break;
      case PageStrings.EXPLORE_USERS_TRACKS_PAGE:
        enabledFilters = ['sort', 'length', 'rating', 'activity', 'elevation_gain'];
        if (this.props.context.currentUser && this.props.context.currentUser.admin) {
          enabledFilters.push('linked');
        }
        searchBoxTypeSubsets = ['area', 'place'];
        placeholderText = StringConstantsMixin.strings.SEARCH.SEARCH_RECORDINGS;
        break;
      case PageStrings.EXPLORE_USERS_MAPS_PAGE:
        enabledFilters = ['sort', 'length', 'rating', 'activity', 'elevation_gain'];
        if (this.props.context.currentUser && this.props.context.currentUser.admin) {
          enabledFilters.push('linked');
        }
        searchBoxTypeSubsets = ['area', 'place'];
        placeholderText = StringConstantsMixin.strings.SEARCH.SEARCH_MAPS;
        break;
      case PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE:
      case PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE:
      case PageStrings.EXPLORE_LIFELINE_PAGE:
        breadcrumbItems = this.createMapBreadcrumbItems();
        searchBoxTypeSubsets = ['all', 'area', 'place', 'trail', 'track', 'map', 'list'];
        break;
      case PageStrings.EXPLORE_TRAIL_MAP_PAGE:
        breadcrumbItems = this.createTrailBreadcrumbItems();
        searchBoxTypeSubsets = ['all', 'area', 'place', 'trail', 'track', 'map', 'list'];
        break;
      default:
        enabledFilters = [];
    }
    let mapCenter;
    switch (this.state.page) {
      case PageStrings.EXPLORE_ALL_PAGE:
      case PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE:
      case PageStrings.EXPLORE_FAVORITE_PAGE:
      case PageStrings.EXPLORE_COMPLETED_PAGE:
      case PageStrings.EXPLORE_CUSTOM_PAGE:
      case PageStrings.EXPLORE_USERS_TRACKS_PAGE:
      case PageStrings.EXPLORE_PENDING_PAGE:
      case PageStrings.EXPLORE_USERS_MAPS_PAGE:
        if (this.refs.searchMap) {
          mapCenter = this.refs.searchMap.getMapCenter();
        }

        return (
          <SearchFilterBar
            clearAllFilters={this.clearAllFilters}
            context={this.props.context}
            defaultLatLng={mapCenter}
            enabledFilters={enabledFilters}
            filters={this.state.filters}
            handleFilterSet={this.handleFilterSet}
            handleFilterSlider={this.handleFilterSlider}
            handleFilterToggle={this.handleFilterToggle}
            handleObjectSelected={this.handleObjectSelected}
            handleQueryTermSet={this.handleQueryTermSet}
            handleSortFilterClick={this.handleSortFilterClick}
            handleTrailSelected={this.handleTrailClick}
            isFilterActive={SearchFiltersUtil.filtersAreActive(this.state.filters)}
            isMobileWidth={this.state.isMobileWidth}
            liveStringSearch={[
              PageStrings.EXPLORE_FAVORITE_PAGE,
              PageStrings.EXPLORE_COMPLETED_PAGE,
              PageStrings.EXPLORE_CUSTOM_PAGE,
              PageStrings.EXPLORE_USERS_TRACKS_PAGE,
              PageStrings.EXPLORE_USERS_MAPS_PAGE
            ].includes(this.state.page)}
            page={this.state.page}
            placeholderText={placeholderText}
            resultsCount={this.state.results ? this.state.results.length : null}
            typeSubsets={searchBoxTypeSubsets}
          />
        );
      case PageStrings.EXPLORE_TRAIL_MAP_PAGE:
      case PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE:
      case PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE:
      case PageStrings.EXPLORE_LIFELINE_PAGE:
        if ((breadcrumbItems && breadcrumbItems.length) || this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE) {
          return (
            <FullscreenBreadcrumbBar
              items={breadcrumbItems}
              showSearch={this.state.page !== PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE}
              onMapPage
              context={this.props.context}
              typeSubsets={searchBoxTypeSubsets}
            />
          );
        }
        return null;
      default:
        return null;
    }
  },
  openUploadRecordingModal() {
    this.openTrailFormModal('tracks', { onTrackAdd: this.handleRecordingRequest, exploreFlag: false });
  },
  getInitialLocationType() {
    let initialLocationType = null;
    if (this.props.initialFilters.locationObject && this.props.initialFilters.locationObject.objectID) {
      initialLocationType = this.props.initialFilters.locationObject.objectID.split('-')[0];
    }
    return initialLocationType;
  },
  showAds() {
    const isPro = this.props.context && this.props.context.proUser;
    return !isPro;
  },
  tabHandler(pageKey) {
    return () => {
      if (pageKey === PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE) {
        logCommunityContentClicked();
      }

      _gaq.push(['_trackEvent', 'Explore Tab Change', pageKey]);
      this.setState({ page: pageKey, results: [], loading: true }, this.replaceHistoryStateAndSearch);
    };
  },
  handlePrimaryCtaClick(option) {
    if (option === 'favorites' || option === 'custom') window.location.href = '/explore';
    if (option === 'maps') window.location.href = '/explore/map/new';
    if (option === 'activities') return this.openUploadRecordingModal();
    return null;
  },
  redirectToMapPage(data) {
    window.location = checkLinkAndAppendLanguage(`/explore/map/${data.slug}?save`);
  },
  saveMapAsClone(data) {
    // Block user with signup if not signed-in
    if (!this.props.context.currentUser) {
      this.blockNonUserCreation('explore-map-new');
      return;
    }

    const { id, name } = data;
    this.updateProgressDialog('saving');
    copyRoute(id, name)
      .then(resp => {
        if (resp.errors) {
          this.handleMapSaveError();
          return;
        }
        this.redirectToMapPage(resp);
      })
      .catch(this.handleMapSaveError);
  },
  createEmptyStates() {
    switch (this.state.page) {
      case PageStrings.EXPLORE_FAVORITE_PAGE:
        return (
          <SearchEmptyState
            option="favorites"
            srcIcon={BookmarkIcon}
            alt={ICON}
            handlePrimaryCtaClick={this.handlePrimaryCtaClick}
            title={KEEP_TRACK}
            subText={TAP_THE_HEART_ICON}
            btnText={START_EXPLORING}
          />
        );
      case PageStrings.EXPLORE_USERS_MAPS_PAGE:
        return (
          <SearchEmptyState
            option="maps"
            srcIcon={MapIcon}
            alt={ICON}
            handlePrimaryCtaClick={this.handlePrimaryCtaClick}
            title={PLAN_YOUR_PERFECT_ROUTE}
            subText={MAP_CREATOR_TOOL}
            btnText={CREATE_MAP}
          />
        );
      case PageStrings.EXPLORE_USERS_TRACKS_PAGE:
        return (
          <SearchEmptyState
            option="activities"
            srcIcon={PointerIcon}
            alt={ICON}
            handlePrimaryCtaClick={this.handlePrimaryCtaClick}
            title={KEEP_TRACK_ACTIVITIES}
            subText={SAVE_ACTIVITIES}
            btnText={UPLOAD_FILE}
          />
        );
      case PageStrings.EXPLORE_COMPLETED_PAGE:
        return <SearchEmptyState option="completed" srcIcon={PointerIcon} alt={ICON} title={COMPLETE_TRAILS} subText={COMPLETED_TAB_LIST} />;
      case PageStrings.EXPLORE_CUSTOM_PAGE:
        return (
          <SearchEmptyState
            option="custom"
            srcIcon={BookmarkIcon}
            alt={ICON}
            handlePrimaryCtaClick={this.handlePrimaryCtaClick}
            title={BUILD_PERSONAL_LIST}
            subText={PERSONAL_LIST_SUBTEXT}
            btnText={START_EXPLORING}
          />
        );
      default:
        return this.createNoResultsObj();
    }
  },
  renderTabBar() {
    if (![PageStrings.EXPLORE_ALL_PAGE, PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE].includes(this.state.page)) {
      return null;
    }
    let resultCount = this.getResultCount();
    if (resultCount >= 1000) {
      resultCount = StringConstantsMixin.strings.SEARCH.MAX_NUM_RESULTS;
    }
    const tabs = [
      {
        inactiveString: StringConstantsMixin.strings.SEARCH.CURATED_TRAILS,
        activeString: `${StringConstantsMixin.strings.SEARCH.CURATED_TRAILS} (${resultCount})`,
        itemKey: PageStrings.EXPLORE_ALL_PAGE
      },
      {
        inactiveString: StringConstantsMixin.strings.SEARCH.COMMUNITY_CONTENT,
        activeString: `${StringConstantsMixin.strings.SEARCH.COMMUNITY_CONTENT} (${resultCount})`,
        itemKey: PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE
      }
    ];
    return <TabBar variant="explore" tabs={tabs} handler={this.tabHandler} activeItemKey={this.state.page} loading={this.state.loading} />;
  },
  leftPaneAndMapTopLeft() {
    // Render leftPane based on page type, filters, and other state
    let leftPane = null;
    let mapTop = 106;
    let mapLeft = 400;
    if (this.state.page === PageStrings.EXPLORE_TRAIL_MAP_PAGE) {
      if (this.state.isMobileWidth && this.state.filters.mobileMap) {
        mapTop = 60;
        mapLeft = 0;
        leftPane = (
          <div id="fullscreen-search-results" className="hide-for-fullscreen-modal" style={{ top: mapTop }}>
            <div className="result-info">
              <span className="result-action explore-back" onClick={() => this.goToTrailPage(this.state.selectedObject)}>
                {StringConstantsMixin.strings.BACK}
              </span>
            </div>
          </div>
        );
      } else {
        let selectedTrailId;
        let selectedTrailSlug;
        if (this.state.selectedObject) {
          selectedTrailId = this.state.selectedObject.ID;
          selectedTrailSlug = LanguageSupportUtil.wrapUrlSafe(
            `/trail/${this.state.selectedObject.slug.replace(/^trail\//, '')}`,
            this.props.context.languageRegionCode
          );
        }
        let trailIframeSrc;
        if (typeof window != 'undefined' && window.location) {
          trailIframeSrc = `//${window.location.host}${selectedTrailSlug}?explore=true`;
        } else if (this.props.iframeUrl) {
          trailIframeSrc = `${this.props.iframeUrl}?explore=true`;
        }
        const currentUser = this.props.context.currentUser;
        if (trailIframeSrc && currentUser) {
          if (currentUser.metric && !this.state.displayMetric) {
            trailIframeSrc += '&u=i';
          } else if (!currentUser.metric && this.state.displayMetric) {
            trailIframeSrc += '&u=m';
          }
        }
        leftPane = (
          <div id="fullscreen-search-results" style={{ width: mapLeft, paddingBottom: 25 }}>
            <div className="result-info">
              <span className="result-action explore-back" onClick={this.backToExplore}>
                {StringConstantsMixin.strings.MORE_TRAILS}
              </span>
              {!this.state.isMobileWidth && (
                <span className="floatright">
                  <a className="expand" href={selectedTrailSlug} data-testid="VIEW_TRAIL_DETAILS">
                    {StringConstantsMixin.strings.VIEW_TRAIL_DETAILS}
                  </a>
                </span>
              )}
            </div>
            <FullscreenTrailDetailsFrame key={`details-${selectedTrailId}`} isMobileWidth={this.state.isMobileWidth} src={trailIframeSrc} />
          </div>
        );
      }
    } else if (this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && this.state.exploreMap) {
      leftPane = (
        <div id="fullscreen-search-results" className="map-creator-panel">
          {this.state.isMobileWidth && this.state.filters.mobileMap && (
            <div className="backToMap">
              <button onClick={this.hideMapMobile}>{StringConstantsMixin.strings.BACK}</button>
            </div>
          )}
          <MapCreatorPanel
            context={this.props.context}
            handleMapUpdate={this.handleMapUpdate}
            initialIsEditing={typeof this.state.exploreMap.ID === 'undefined'}
            linkedTrail={this.state.trackTrail}
            map={this.state.exploreMap}
            mapboxAccessToken={this.props.mapboxAccessToken}
            messagingChannel={this.messagingChannel}
            openShareModal={this.openShareModal}
            openTrailFormModal={this.openTrailFormModal}
            resultCardFunctions={this.resultCardFunctions}
            saveMapChanges={this.saveMapChanges}
            updateExploreMap={this.updateExploreMap}
            updateMapPhotos={this.handleTrackPhotosUpload}
            routeInfo={this.state.routeInfo}
            updateProgressDialog={this.updateProgressDialog}
            showMapMobile={this.showMapMobile}
            hidePanel={this.state.isMobileWidth && this.state.filters.mobileMap}
            handleRouteInfoChanged={this.handleRouteInfoChanged}
            listMethods={this.props.listMethods}
            saveMapAsClone={this.saveMapAsClone}
          />
        </div>
      );
    } else if (this.state.page === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE || this.state.page === PageStrings.EXPLORE_LIFELINE_PAGE) {
      mapTop = this.state.isMobileWidth ? 60 : 101;
      if (this.state.exploreMap && this.state.selectedObject && this.state.page !== PageStrings.EXPLORE_LIFELINE_PAGE) {
        let resultInfoBody;
        if (this.state.isMobileWidth && this.state.filters.mobileMap) {
          resultInfoBody = (
            <span className="result-action explore-back" onClick={this.hideMapMobile}>
              {StringConstantsMixin.strings.BACK}
            </span>
          );
        } else if (
          this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE &&
          this.props.userInfo &&
          this.props.userInfo.slug != StringConstantsMixin.constants.MAGIC.ANONYMOUS_MAP_USERNAME
        ) {
          resultInfoBody = (
            <span className="result-action explore-back" onClick={this.backToExplore}>
              {StringConstantsMixin.strings.MORE_MAPS}
            </span>
          );
        } else if (this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && this.state.selectedObject && !this.state.selectedObject.ID) {
          resultInfoBody = <h1 className="result-action">{StringConstantsMixin.strings.TRACK_DETAIL.CREATE_MAP}</h1>;
        } else if (this.state.page === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE) {
          resultInfoBody = (
            <span className="result-action explore-back" onClick={this.backToExplore}>
              {StringConstantsMixin.strings.MORE_RECORDINGS}
            </span>
          );
        }
        const headerBarClass = this.state.isMobileWidth ? 'hide-for-fullscreen-modal' : '';
        leftPane = (
          <div id="fullscreen-search-results" className={headerBarClass} style={{ width: mapLeft }}>
            <div className="result-info">{resultInfoBody}</div>
            <TrackPanel
              openTrailFormModal={this.openTrailFormModal}
              context={this.props.context}
              currentPage={this.state.page}
              data={JSON.parse(JSON.stringify(this.state.exploreMap))}
              getMapViewCenter={this.getMapViewCenter}
              handleMapInfoChanged={this.handleMapInfoChanged}
              handleMapUpdate={this.handleMapUpdate}
              handlePhotosUpload={this.handleTrackPhotosUpload}
              handleTrackDefaultPhotoChanged={this.handleTrackDefaultPhotoChanged}
              handleShareClick={this.openShareModal}
              isMobileWidth={this.state.isMobileWidth}
              key={`track-details-${this.state.exploreMap.id}`}
              messagingChannel={this.messagingChannel}
              result={this.state.selectedObject}
              trackTrail={this.state.trackTrail}
              resultCardFunctions={this.resultCardFunctions}
              listMethods={this.props.listMethods}
              showAds={this.showAds()}
              mapboxAccessToken={this.props.mapboxAccessToken}
              handleTrackUpdate={this.handleRecordingRequest}
              saveMapAsClone={this.saveMapAsClone}
              blockNonUserCreation={this.blockNonUserCreation}
              showMapMobile={this.showMapMobile}
            />
          </div>
        );
      } else if (this.state.page === PageStrings.EXPLORE_LIFELINE_PAGE) {
        let resultInfoBody;
        if (this.state.isMobileWidth && this.state.filters.mobileMap) {
          resultInfoBody = (
            <div className="result-info">
              <span className="result-action explore-back" onClick={this.hideMapMobile}>
                {StringConstantsMixin.strings.BACK}
              </span>
            </div>
          );
        }
        leftPane = (
          <div id="fullscreen-search-results" style={{ width: mapLeft }}>
            {resultInfoBody}
            <FullscreenLifelineDetails
              context={this.props.context}
              data={JSON.parse(JSON.stringify(this.state.exploreMap))}
              isMobileWidth={this.state.isMobileWidth}
              key={`track-details-${this.state.exploreMap.id}`}
              lifeline={this.state.lifeline}
              messagingChannel={this.messagingChannel}
              resultCardFunctions={this.resultCardFunctions}
              listMethods={this.props.listMethods}
              trackTrail={this.state.trackTrail}
              sampledElevationGain={this.state.routeInfo ? this.state.routeInfo.elevationGain : null}
              showAds={this.showAds()}
            />
          </div>
        );
      } else {
        leftPane = (
          <div id="fullscreen-search-results" style={{ width: mapLeft }}>
            <div className="result-info">
              {this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && (
                <span className="result-action explore-back" onClick={this.backToExplore}>
                  {StringConstantsMixin.strings.MORE_MAPS}
                </span>
              )}
              {this.state.page === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE && (
                <span className="result-action explore-back" onClick={this.backToExplore}>
                  {StringConstantsMixin.strings.MORE_RECORDINGS}
                </span>
              )}
            </div>
            <div id="iframe-loading" style={{ display: 'block' }}>
              {this.state.page === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE && (
                <div className="header">{StringConstantsMixin.strings.SEARCH.RECORDING_LOAD_INFO}</div>
              )}
              {this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && (
                <div className="header">{StringConstantsMixin.strings.SEARCH.MAP_LOAD_INFO}</div>
              )}
              {this.state.page === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE && (
                <div className="icon trailpost">
                  <span className="icon-text">{StringConstantsMixin.strings.SEARCH.RECORDING_LOAD_MSG}</span>
                </div>
              )}
              {this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && (
                <div className="icon trailpost">
                  <span className="icon-text">{StringConstantsMixin.strings.SEARCH.MAP_LOAD_MSG}</span>
                </div>
              )}
            </div>
          </div>
        );
      }
    } else {
      let showBottomButton;
      let bottomButtonAction;
      let bottomButtonText;
      let showToggleButton;
      if (
        this.state.page === PageStrings.EXPLORE_FAVORITE_PAGE ||
        this.state.page === PageStrings.EXPLORE_COMPLETED_PAGE ||
        this.state.page === PageStrings.EXPLORE_CUSTOM_PAGE
      ) {
        showToggleButton = true;
        bottomButtonAction = this.toggleNearbyTrailsOverlay;
        bottomButtonText = StringConstantsMixin.strings.OVERLAYS.NEARBY_TRAILS;
      } else if (this.state.page === PageStrings.EXPLORE_USERS_MAPS_PAGE) {
        showBottomButton =
          this.props.context.currentUser && this.props.context.currentUser.slug == this.props.initialUserSlug && !isEmpty(this.state.results);
        bottomButtonAction = this.handleNewMapClick;
        bottomButtonText = StringConstantsMixin.strings.SEARCH.CREATE_NEW_MAP;
      } else if (this.state.page === PageStrings.EXPLORE_USERS_TRACKS_PAGE && !this.props.context.mobileBrowser) {
        showBottomButton =
          this.props.context.currentUser && this.props.context.currentUser.slug == this.props.initialUserSlug && !isEmpty(this.state.results);
        bottomButtonAction = this.openUploadRecordingModal;
        bottomButtonText = StringConstantsMixin.strings.CONTRIBUTE.UPLOAD_FILE;
      }
      leftPane = (
        <FullscreenSearchResultList
          allowReordering={this.state.isEditing && this.props.listId} // Only re-orderable items belong to a list with an ID
          bottomButtonAction={bottomButtonAction}
          bottomButtonText={bottomButtonText}
          changeParentResultOrder={this.changeParentResultOrder}
          clearAllFilters={this.clearAllFilters}
          context={this.props.context}
          currentPage={this.state.page}
          customList={this.props.initialCustomList}
          filtersSet={SearchFiltersUtil.filtersAreActive(this.state.filters)}
          handleCopyListClick={this.handleCopyListClick}
          handleNewMapClick={this.handleNewMapClick}
          handleResultsEditClick={() => this.updateEditingStatus(!this.state.isEditing)}
          h1Obj={this.createH1Obj()}
          isEditing={this.state.isEditing}
          isMobileWidth={this.state.isMobileWidth}
          listCopyString={this.state.listCopyString}
          messagingChannel={this.messagingChannel}
          noResultsObj={this.createEmptyStates()}
          resultCardFunctions={this.resultCardFunctions}
          resultCountObj={this.createResultCountObj()}
          results={this.state.results}
          nearbyTrailsShown={this.state.nearbyTrailsShown}
          showToggleButton={showToggleButton}
          showBottomButton={showBottomButton}
          showNewButton={!showBottomButton && this.props.context.currentUser && this.props.context.currentUser.slug == this.props.initialUserSlug}
          showAds={this.showAds()}
          tabBar={this.renderTabBar()}
          userInfo={this.props.userInfo}
          openUploadRecordingModal={this.openUploadRecordingModal}
          loading={this.state.loading}
          listMethods={this.props.listMethods}
        />
      );
    }
    return {
      leftPane,
      mapTop,
      mapLeft
    };
  },
  openShareModal(shareObject) {
    this.setState({ showShareModal: true, shareObject });
  },
  closeShareModal() {
    this.setState({ showShareModal: false });
  },
  openDownloadRouteModal(downloadObject) {
    if (!this.props.context?.currentUser) {
      const returnToUrl = window.location.pathname + window.location.search;
      modalSignup('trail-more-gpx', returnToUrl);
    }
    this.setState({ showDownloadRouteModal: true, downloadObject });
  },
  toggleDownloadModal() {
    this.setState({ showDownloadRouteModal: !this.state.showDownloadRouteModal });
  },
  openTrailFormModal(activeTrailFormModal, trailFormProps) {
    this.setState({ activeTrailFormModal, trailFormProps });
  },
  closeTrailFormModal() {
    this.setState({ activeTrailFormModal: null, trailFormProps: {} });
  },
  renderTrailFormModal() {
    if (!this.state.activeTrailFormModal) {
      return null;
    }

    switch (this.state.activeTrailFormModal) {
      case 'reviews':
        return (
          <ReviewFormModal
            {...this.state.trailFormProps}
            closeReviewModal={wrapEventHandler(this.closeTrailFormModal)}
            exploreFlag
            isMobile={this.props.context.mobileBrowser}
          />
        );
      case 'photos':
        return <PhotoUploadModal {...this.state.trailFormProps} closePhotoModal={this.closeTrailFormModal} />;
      case 'tracks':
        if (this.props.context.featureFlags.flexiblePrivacy) {
          return (
            <ActivityUploadModal
              exploreFlag
              {...this.state.trailFormProps}
              closeModal={this.closeTrailFormModal}
              context={this.props.context}
              languageRegionCode={this.props.context.languageRegionCode}
            />
          );
        }

        return <TrackUploadModal exploreFlag closeActiveTrailModal={this.closeTrailFormModal} {...this.state.trailFormProps} />;
      default:
        return null;
    }
  },

  // Code extracted from ListFunctionalityMixin
  handleListReordering() {
    const { isEditing, results } = this.state;
    const { listId } = this.props;
    if (!isEditing) {
      return;
    }

    const orderedListItemIds = results.map(
      result => this.props.listMethods.getListItemInList(this.props.listId, result.type, result.ID, this.props.userListItems)?.id
    );

    reorderList(listId, orderedListItemIds)
      .then(updatedListItems => {
        this.props.listMethods.updateListOrder(updatedListItems, listId);
        this.setState({ isEditing: false });
      })
      .catch(logError);
  },

  handleCopyListClick() {
    if (!this.props.context.currentUser) {
      const returnToUrl = window.location.pathname + window.location.search;
      modalSignup('explore-list', returnToUrl);
      return;
    }

    this.setState({ listCopyString: 'Copying...' });
    copyList(this.state.customList.id).then(list => {
      this.setState({ listCopyString: 'Successfully Copied' });
      if (list) {
        window.location = window.checkLinkAndAppendLanguage(`/explore/lists/${list.slug}`);
      }
    });
  },

  render() {
    const { leftPane, mapLeft } = this.leftPaneAndMapTopLeft();
    return (
      <Page context={this.props}>
        <div>
          <div id="modalPortal" />
          {this.renderFilterBar()}
          {renderShareModal(
            this.state.showShareModal,
            this.closeShareModal,
            this.state.shareObject,
            this.props.context.currentUser,
            this.props.context.languageRegionCode,
            this.props.context.locale
          )}
          {this.renderTrailFormModal()}
          {this.renderProgressDialog()}
          {this.props.context.currentUser && this.state.showDownloadRouteModal && (
            <DownloadRouteModal toggleDownloadModal={this.toggleDownloadModal} trailSlug={this.state.downloadObject?.slug} />
          )}
          <div className="map-list-container">
            {leftPane}
            <FullscreenSearchMap
              context={this.props.context}
              currentPage={this.state.page}
              customList={this.props.initialCustomList}
              divLeft={mapLeft}
              exploreMap={this.state.exploreMap}
              handleMapBoundsChanged={this.handleMapBoundsChanged}
              handleMapCreate={this.handleMapCreate}
              handleMapUpdate={this.handleMapUpdate}
              handleOverlayToggled={this.handleOverlayToggled}
              handleRouteInfoChanged={this.handleRouteInfoChanged}
              handleTrailClick={this.handleTrailClick}
              handleTrackClick={this.handleTrackClick}
              handleMapClick={this.handleMapClick}
              handleWaypointAdded={this.addWaypoint}
              handleWaypointRemoved={this.removeWaypoint}
              initialBounds={this.props.initialBounds}
              initialCenter={this.props.initialCenter}
              initialLocationType={this.getInitialLocationType()}
              isDisplayingMobileMap={this.state.filters && this.state.filters.mobileMap}
              isMobileWidth={this.state.isMobileWidth}
              key="explore-search-map"
              lifeline={this.state.lifeline}
              listMethods={this.props.listMethods}
              mapboxAccessToken={this.props.mapboxAccessToken}
              mapDivId="map"
              mapProviderName="mapBox"
              messagingChannel={this.messagingChannel}
              page={this.state.page}
              plannerMap={this.state.routeInfo ? this.state.routeInfo.plannerMap : null}
              ref="searchMap"
              resultCardFunctions={this.getResultCardFunctions()}
              results={this.state.results}
              saveEditEndpointChanges={this.saveEditEndpointChanges}
              selectedObject={this.state.selectedObject}
            />
          </div>
        </div>
      </Page>
    );
  }
});

export { FullscreenSearchApp };
